module.exports = __webpack_public_path__ + "img/atlas_logo_magenta.0eeba066.jpg";